import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DatePipe} from '@angular/common';

import {SharedModule} from '../shared/shared.module';
import {AuditListComponent} from './audit/audit-list/audit-list.component';
import {AuditRoutingModule} from './audit-routing.module';
import {AuditAddComponent} from './audit/audit-add/audit-add.component';
import {AuditNavBarComponent} from './audit-nav-bar/audit-nav-bar.component';
import {AuditService} from './audit.service';
import {AuditDetailsComponent} from './audit/audit-details/audit-details.component';
import {AuditListResolver, AuditResolver} from './audit.resolvers';
import {AuditEditDialogComponent} from './audit/audit-edit-dialog/audit-edit-dialog.component';
import {AuditEditFormComponent} from './audit/audit-edit-form/audit-edit-form.component';
import {AuditCapaStatusComponent} from './audit-capa-status/audit-capa-status.component';
import { AuditFilterFormComponent } from './audit/audit-filter-form/audit-filter-form.component';
import { AuditFilterDialogComponent } from './audit/audit-filter-dialog/audit-filter-dialog.component';
import {MatListModule} from '@angular/material/list';
import { FindingListComponent } from './finding/finding-list/finding-list.component';
import { FindingService } from './finding.service';
import { FindingAddComponent } from './finding/finding-add/finding-add.component';
import { FindingEditFormComponent } from './finding/finding-edit-form/finding-edit-form.component';
import { FindingDetailComponent } from './finding/finding-detail/finding-detail.component';
import { FindingEditDialogComponent } from './finding/finding-edit-dialog/finding-edit-dialog.component';
import { CapaListComponent } from './capa/capa-list/capa-list.component';
import { CapaEditFormComponent } from './capa/capa-edit-form/capa-edit-form.component';
import { CapaAddComponent } from './capa/capa-add/capa-add.component';
import { CapaService } from './capa.service';
import { MatRadioModule } from '@angular/material/radio';
import { CapaDetailComponent } from './capa/capa-detail/capa-detail.component';
import { CapaEditDialogComponent } from './capa/capa-edit-dialog/capa-edit-dialog.component';
import { MatExpansionModule } from '@angular/material';
import { EvidenceListComponent } from './evidence/evidence-list/evidence-list.component';
import { CapaDetailExpansionComponent } from './capa/capa-detail-expansion/capa-detail-expansion.component';
import { EvidenceAddDialogComponent } from './evidence/evidence-add-dialog/evidence-add-dialog.component';
import { EvidenceEditFormComponent } from './evidence/evidence-edit-form/evidence-edit-form.component';
import { ngfModule } from 'angular-file';
import { FindingDetailExpansionComponent } from './finding/finding-detail-expansion/finding-detail-expansion.component';
import { AuditDetailExpansionComponent } from './audit/audit-detail-expansion/audit-detail-expansion.component';
import { ActivityHistoryExpansionComponent } from './capa/activity-history-expansion/activity-history-expansion.component';
import { EvidenceApprovalListComponent } from './evidence/evidence-approval-list/evidence-approval-list.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AuditUpdateHistoryComponent } from './audit/audit-update-history/audit-update-history.component';
import { CapaUpdateHistoryComponent } from './capa/capa-update-history/capa-update-history.component';
import { EvidenceUpdateHistoryComponent } from './evidence/evidence-update-history/evidence-update-history.component';

@NgModule({
  declarations: [
    AuditAddComponent,
    AuditCapaStatusComponent,
    AuditDetailsComponent,
    AuditEditDialogComponent,
    AuditEditFormComponent,
    AuditListComponent,
    AuditNavBarComponent,
    AuditFilterFormComponent,
    AuditFilterDialogComponent,
    FindingListComponent,
    FindingAddComponent,
    FindingEditFormComponent,
    FindingDetailComponent,
    FindingEditDialogComponent,
    CapaListComponent,
    CapaEditFormComponent,
    CapaAddComponent,
    CapaDetailComponent,
    CapaEditDialogComponent,
    EvidenceListComponent,
    CapaDetailExpansionComponent,
    EvidenceAddDialogComponent,
    EvidenceEditFormComponent,
    FindingDetailExpansionComponent,
    AuditDetailExpansionComponent,
    ActivityHistoryExpansionComponent,
    EvidenceApprovalListComponent,
    AuditUpdateHistoryComponent,    
    CapaUpdateHistoryComponent, 
    EvidenceUpdateHistoryComponent,
  ],
  entryComponents: [
    AuditEditDialogComponent,
    AuditFilterDialogComponent,
    FindingEditDialogComponent,
    CapaEditDialogComponent,
    EvidenceAddDialogComponent,
  ],
  imports: [
    AuditRoutingModule,
    ReactiveFormsModule,
    SharedModule,
    MatListModule,
    MatRadioModule,
    MatExpansionModule,
    ngfModule,
    FormsModule,
    NgxMatSelectSearchModule,
  ],
  providers: [
    AuditService,
    AuditResolver,
    AuditListResolver,
    DatePipe,
    FindingService,
    CapaService,
  ],
  exports: [
    CapaListComponent,
    CapaAddComponent,
  ]
})
export class AuditModule {}
